// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"nX-z","smallCardRow":"oX-z","largeCardRow":"pX-z","productSearchRow":"qX-z","curatedRow":"rX-z"};